import React, { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';

interface Props {
  actionsSlot: ReactNode;
  departmentsSlot: ReactNode;
}

export const Header = ({ actionsSlot, departmentsSlot }: Props) => (
  <Box className="managerHeader">
    <Typography component="span" variant="h6">
      Opportunity Stages
    </Typography>

    <Stack direction="row" gap="0.5rem">
      {departmentsSlot} {actionsSlot}
    </Stack>
  </Box>
);
